import { useContext } from "react";
import { CommerceContext } from "../context/CommerceContext";

export function useCommerce() {
  const context = useContext(CommerceContext);

  if (context === undefined) {
    throw new Error("useCommerce must be used within a CommerceProvider.");
  }

  return context;
}

export default useCommerce;
